import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/404',
      name: '404',
      component: () => import('./components/404.vue')
    },     
    {
      path: '/',
      name: 'home',
      component: () => import('./components/Home.vue')
    },  
    {
      path: '/article/:slug',
      name: 'article',
      component: () => import('./components/Article.vue')
    },  
    {
      path: '/gdpr/modificare-consimtamant',
      name: 'modificare-consimtamant',
      component: () => import('./components/Gdpr/ModificareConsimtamant.vue')
    },   
    {
      path: '/gdpr/vezi-informatii/:hash',
      name: 'vezi-informatii',
      component: () => import('./components/Gdpr/ModificaDate.vue')
    },   
    {
      path: '/gdpr/solicitare-date-personale',
      name: 'solicitare-date',
      component: () => import('./components/Gdpr/SolicitareDate.vue')
    }
  ]
})
